<template>
  <div class="container-fluid p-0">
    <Loading v-if="loadingRender"></Loading>

    <Card>
      <template slot="header">
        <h3>گزارش توسعه</h3>
        <hr />
      </template>
      <template slot="content">
        <div class="row">
          <div class="col-11 p-2 mx-4">
            <div class="row">
              <div class="col-md-3 col-12">
                <small>انتخاب فیلتر</small>
                <SearchableCombo :edit="false" :grp="null" :code="null" @ResultCombo="GetFilter" :rownumintable="3" :action="'Reports/DevelopeFilters'" :method="'GET'" :idinput="'filter'" :keyItem="'filter'" :ClassProps="'required'" :disabled="false"> </SearchableCombo>
              </div>
              <div class="col-md-3 col-12">
                <div class="form-control mt-4 text-center">
                  <div class="custom-control custom-switch">
                    <input type="checkbox" @change="changetable" class="custom-control-input InputText" id="AllorNoWarning" v-model="AllorNoWarning" />
                    <label class="custom-control-label" for="AllorNoWarning">همه </label>
                    <small class="mr-5">بدون هشدار مرتبط</small>
                  </div>
                </div>
              </div>
              <div class="col-md-3 col-12" dir="rtl">
                <small>نوع مشتری</small>
                <treeselect
                  name="demo"
                  :multiple="true"
                  :clearable="true"
                  :searchable="true"
                  :disabled="false"
                  :open-on-click="true"
                  :open-on-focus="true"
                  :clear-on-select="false"
                  :close-on-select="false"
                  :always-open="false"
                  :append-to-body="false"
                  :options="NoeCustomerOptions"
                  v-model="NoeMoshtariList"
                  :normalizer="normalizer"
                  @select="SelectCustomerNameNoe"
                  @deselect="DeSelectCustomerNameNoe"
                  value-consists-of="LEAF_PRIORITY"
                >
                </treeselect>
              </div>
              <div class="col-md-3 col-12" dir="rtl">
                <small>نوع مجوز</small>
                <treeselect
                  name="demo"
                  :multiple="true"
                  :clearable="true"
                  :searchable="true"
                  :disabled="false"
                  :open-on-click="true"
                  :open-on-focus="true"
                  :clear-on-select="false"
                  :close-on-select="false"
                  :always-open="false"
                  :append-to-body="false"
                  :options="NoeMojavezOptions"
                  v-model="NoeMojavezList"
                  :normalizer="normalizer"
                  @select="SelectNoeMojavez"
                  @deselect="DeselectNoeMojavez"
                  value-consists-of="LEAF_PRIORITY"
                >
                </treeselect>
              </div>
              <div class="col-12">
                <div class="row">
                  <div v-for="(item, index) in Filters" :key="index" class="col-lg-3 col-12 mt-2">
                    <small id="lblShowInSlides">{{ item.name }}</small>
                    <small v-if="item.element.moxafafName != null"> ({{ item.element.moxafafName }})</small>
                    <div class="custom-control custom-switch mt-2">
                      <input type="checkbox" class="custom-control-input InputText" :id="item.name" v-model="item.checked" />
                      <label class="custom-control-label mr-2" :for="item.name"> </label>
                    </div>
                  </div>
                  <div class="col-12">
                    <div class="row">
                      <div class="col-lg-8 col-12"></div>
                      <div class="col-lg-4 col-12">
                        <button class="btn btn-success w-100" @click="SendFilters">ساخت گزارش</button>
                      </div>
                    </div>
                  </div>

                  <div class="col-12">
                    <BnpGrid Selectable :Sortable="true" :IsReport="true" :ListCommaReport="[]" :HeaderReport="'لیست بدهکاران '" :action="true" :propsRows="propsRows" :propsColumn="propsColumn" :NoRowNum="true" v-if="$store.state.renderComponentGrid">
                      <template slot="action-slot" slot-scope="props">
                        <a href="javascript:;" class="mr-2 badge" data-title="مشاهده جزئیات" @click="$FindeCustomerById('DetailCustomer', props.props.id, false, $event)" @click.middle="$FindeCustomerById('DetailCustomer', props.props.id, false, $event)"
                          ><h6><span class="fas fa-eye font-weight-bold hover-danger"></span></h6
                        ></a>
                        <a v-if="props.props.tasks.length > 0" href="javascript:;" class="mr-2 badge" data-title="هشدارها" @click="OnTask(props.props)"
                          ><h6><span class="fas fa-bell t hover-danger"></span></h6
                        ></a>

                        <a href="javascript:;" class="mr-2 badge" data-title="افزودن هشدار" @click="OnAddTask(props.props)"
                          ><h6><span class="fas fa-plus t hover-success"></span></h6
                        ></a>
                      </template>
                      <template slot="customerName" slot-scope="props">
                        <span> {{ props.props.customerName }}</span> <span v-if="props.props.baygani">(بایگانی شده)</span>
                      </template>
                    </BnpGrid>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <modal v-if="$store.state.Modal" :InheritanceTheme="true" :IsFooter="false" :Size="Modal1 ? 'Sm' : 'Lg'">
            <template v-if="Modal1" v-slot:body>
              <div v-for="(item, index) in modalTask.tasks" :key="index" class="row">
                <div class="col-1"></div>
                <div class="col-10 p-2 Rounded border container">
                  <div class="row">
                    <div class="col-12">
                      <h5>{{ item.taskSubject }}</h5>
                      <hr />
                    </div>
                    <div class="col-8">
                      {{ item.taskDes }}
                    </div>
                    <div class="col-4">
                      مهلت انجام:
                      <br />
                      {{ item.doneDeadline }}
                    </div>
                  </div>
                </div>
                <div class="col-1"></div>
              </div>
            </template>
            <template v-else v-slot:body>
              <DetailTask @Inserted="AddTaskSuccess" :fixedTitle="'هشدار توسعه!' + falseFilternames" :PropsCustomer="modalTask.id" :propsAdd="true"></DetailTask>
            </template>
          </modal>
        </div>
      </template>
    </Card>
  </div>
</template>
<script>
import Card from '@/components/Card/Card.vue'
import SearchableCombo from '@/components/Combo/SearchableCombo.vue'
import BnpGrid from '@/components/BnpGrid/BnpGrid.vue'
import Modal from '../../Modal/Modal.vue'
import DetailTask from '../Tasks/DetailTask.vue'
import Loading from '@/components/Loader/Loading.vue'
import Treeselect from '@riophae/vue-treeselect'

export default {
  data() {
    return {
      loadingRender: false,
      PageData: [],
      AllorNoWarning: false,
      Filters: [],
      IsInArray: false,
      NoeMoshtariList: [],
      NoeMojavezOptions: [],
      NoeCustomerOptions: [],
      propsColumn: [
        { name: 'customerCode', label: ' کد مشتری', visibility: true },
        { name: 'customerName', label: 'نام مشتری', visibility: true },
        { name: 'customerCode', label: ' کد مشتری', visibility: false },
        { name: 'tblCombogrp37AxarinVazeitName', label: 'وضعیت فعالیت', visibility: true },
      ],
      propsRows: [],
      Modal1: false,
      modalTask: [],
      falseFilternames: '',
      normalizer(node) {
        return {
          id: node.id,
          label: node.name,
        }
      },
    }
  },
  created() {
    this.GetNoeCustomer()
  },
  components: { Card, SearchableCombo, BnpGrid, Modal, DetailTask, Loading, Treeselect },
  methods: {
    GetFilter(data) {
      this.IsInArray = false
      this.checkFilter(data)
      data.checked = false
      if (data.id != null) {
        if (!this.IsInArray) {
          this.Filters.push(data)
        }
      }
    },
    checkFilter(data) {
      this.Filters.forEach((item) => {
        if (item.id == data.id) {
          this.IsInArray = true
        }
      })
    },
    SendFilters() {
      var trueFilters = []
      var falseFilters = []
      this.Filters.forEach((item) => {
        if (item.checked) {
          trueFilters.push(item.id)
        } else {
          falseFilters.push(item.id)
          this.falseFilternames += '، ' + item.name
        }
      })
      this.loadingRender = true
      var DataAxios = { Method: 'POST', Action: 'Reports/Develepreport', ArryfildValue: { trueFilters: trueFilters, falseFilters: falseFilters, NoeMoshtariList: this.NoeMoshtariList, NoeMojavezList: this.NoeMojavezList } }
      console.warn(DataAxios.ArryfildValue)

      this.$PostData(DataAxios)
        .then((result) => {
          this.PageData = result
          this.changetable()
        })
        .finally(() => {
          this.loadingRender = false
        })
    },
    // OnDetail(data) {
    //   this.$router.push({ name: 'DetailCustomer', params: { tblCustomerId: data.id } })
    // },
    changetable() {
      var temp = JSON.parse(JSON.stringify(this.PageData))

      if (this.AllorNoWarning) {
        this.propsRows = temp
      } else {
        this.propsRows = temp.filter((x) => x.tasks.length == 0)
      }
      this.$store.state.renderComponentGrid = false
      this.$nextTick(() => {
        this.$store.state.renderComponentGrid = true
      })
    },
    OnTask(data) {
      this.modalTask = data
      this.Modal1 = true
      this.$store.state.Modal = true
    },
    OnAddTask(data) {
      this.modalTask = data
      this.Modal1 = false
      this.$store.state.Modal = true
    },
    AddTaskSuccess(data) {
      if (data.done == 'OK') {
        this.modalTask = []
        this.Modal1 = false
        this.$store.state.Modal = false
      }
    },
    DeSelectCustomerNameNoe(node) {},
    SelectCustomerNameNoe(node) {},
    DeselectNoeMojavez(node) {},
    SelectNoeMojavez(node) {},
    GetNoeCustomer() {
      var DataAxios = { Action: 'TblCrmCombo/GetComboById', Method: 'POST', ArryfildValue: { Id: 4 } }
      this.$PostData(DataAxios).then((result) => {
        this.NoeCustomerOptions = result
      })
      var DataAxios = { Action: 'TblCrmCombo/GetComboById', Method: 'POST', ArryfildValue: { Id: 35 } }
      this.$PostData(DataAxios).then((result) => {
        this.NoeMojavezOptions = result
      })
    },
  },
}
</script>
<style scoped>
.Rounded {
  border-radius: 15px !important;
}
</style>
